import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { OrdersModule } from '@vendasta/orders';
import {
  SalesOrderConfirmationModule,
  SalesOrderContentsModule,
  SalesOrderDetailsCardModule,
  SalesOrderFormModule,
} from '@vendasta/sales-ui';
import en from '../../assets/i18n/en_devel.json';
import { OrderApprovePageComponent } from './order-approve-page/order-approve-page.component';
import { OrdersService } from './orders.service';
import { DeclineDialogModule } from './decline-dialog/decline-dialog.module';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LexiconModule } from '@galaxy/lexicon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SalesOrderDetailsCardModule,
    SalesOrderContentsModule,
    SalesOrderFormModule,
    MatProgressSpinnerModule,
    LexiconModule.forChild({
      componentName: 'business-center/business-center-client',
      baseTranslation: en,
    }),
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    SalesOrderConfirmationModule,
    DeclineDialogModule,
    OrdersModule,
    GalaxyPageModule,
    MatTooltipModule,
  ],
  providers: [OrdersService, TranslateService],
  declarations: [OrderApprovePageComponent, LanguageSelectorComponent],
})
export class PublicSalesOrderModule {}
